import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import styles from './PlatformSelect.module.scss'

// Custom styles
const customStyles = {
  control: (provided: any, state: any) => ({
    ...provided,
    overflow: 'hidden',
    height: '2rem',
    borderRadius: '0.5rem',
    color: '#212121 !important',
    textOverflow: 'ellipsis',
    fontFamily: "Work Sans",
    fontSize: '0.6875rem',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '0.875rem',
    cursor: 'pointer',
    borderColor: state.isFocused ? '#965AE5 !important' : '#D4D4D4 !important', // purple on focus
    boxShadow: 'none !important',
    background: '#F9F9F9',
  }),
  menu: (provided: any) => ({
    ...provided,
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    color: state.isSelected ? '#965AE5' : '#56595C',
    fontFamily: "Work Sans",
    fontSize: '0.6875rem',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '0.875rem',
    cursor: 'pointer',
    padding: '12px',
    background: '#FFF',
    borderBottom: '1px solid #D4D4D4'
  }),
};

const PlatformSelect = ({ value, handleSelectedValue, options }) => {
  var selectedOption = options.find((opt) => opt.uuid === value);

  return (
    <div className={styles.container}>
      <label
        htmlFor="sales-channel"
        className={styles.label}
      >
        Sales Channel
      </label>
      <Select
        inputId="sales-channel"
        options={options.map(opt => ({
          ...opt,
          value: opt.uuid  // override value to be uuid
        }))}
        value={selectedOption}
        onChange={(selected) => handleSelectedValue(selected.uuid)}
        placeholder="Select sales channel"
        getOptionLabel={(e) => e.label}
        getOptionValue={(e) => e.uuid}
        styles={customStyles}
      />
    </div>
  );
};

export default PlatformSelect;